import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useUserIdentityState } from '@provider/user-identity';
import { deleteNotificationRequest } from './api.delete-notification.request.js';
import { getNotificationsKey } from './api.get-notifications.query.js';

function useDeleteNotificationMutation() {
  const client = useQueryClient();
  const user = useUserIdentityState(state => state.user);
  return useMutation(deleteNotificationMutation(client, user));
}

/**
 * Deletes a team and removes it from the internal store collection
 * optimistically.
 */
const deleteNotificationMutation = (client, user) => {
  return {
    mutationKey: ["user-area/notifications/delete", user?.id],
    mutationFn: async notifications => {
      await Promise.all(notifications.map(it => deleteNotificationRequest(it)));
    },
    onMutate: async deleted => {
      if (deleted.length === 0) {
        return;
      }
      await client.cancelQueries({
        queryKey: getNotificationsKey(user)
      });
      client.setQueryData(getNotificationsKey(user), previous => previous?.filter(notification => !deleted.map(it => it.id).includes(notification.id)));
    }
  };
};

export { useDeleteNotificationMutation };
//# sourceMappingURL=api.delete-notification.mutation.js.map
